import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { LayoutService } from '../../../../RefModules/_metronic/core/services/layout.service';
import { Router } from '@angular/router';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';
import { ScanBarcodeComponent } from 'src/app/Modules/management/components/modals/organization/scan-barcode/scan-barcode.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstanceTypes, LicenceInstanceTypesIndex } from 'src/app/Modules/management/enums/InstanceType';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-home-header',
    templateUrl: './home-header.component.html',
    styleUrls: ['./home-header.component.scss'],
    standalone: false,
})
export class HomeHeaderComponent implements OnInit {
    IA = LogoNames.IA;
    JA = LogoNames.JA;
    PA = LogoNames.PA;
    CA = LogoNames.CA;
    headerContainerCSSClasses: string;
    headerMenuSelfDisplay: boolean;
    headerMenuSelfStatic: boolean;
    asideSelfDisplay: boolean;
    headerLogo: string;
    headerSelfTheme: string;
    headerMenuCSSClasses;
    headerMenuHTMLAttributes: any = {};
    routerLoaderTimout: any;
    ulCSSClasses: string;
    rootArrowEnabled: boolean;
    location: Location;
    headerMenuDesktopToggle: string;
    open: boolean = false;
    display = 'none';
    isIdmsShown: boolean;
    isInformateShown: boolean;
    isIdmsVisible: boolean = false;
    isMatrixVisible: boolean = true;
    isDashboardVisible: boolean = true;
    isInformateVisible: boolean;
    disabled: boolean = true;
    isPlantManager: boolean;
    isprojectManger: boolean;
    isStandardFlange: boolean;
    isCustomFlange: boolean;
    isClamp: boolean;
    isEngineeredJointVisible: boolean;
    isReports: boolean = false;
    isIceDatabaseVisible: boolean = false;
    displaySelectOrganization: boolean = false;
    displayCDMS: boolean = false;
    displayCDMSLinks: boolean = false;

    constructor(
        private layout: LayoutService,
        private eRef: ElementRef,
        private globalEmittersService: GlobalEmittersService,
        private router: Router,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private modalService: NgbModal
    ) {
        this.isStandardFlange = false;
        this.isCustomFlange = false;
        this.isClamp = false;
        this.isEngineeredJointVisible = false;
        this.isInformateVisible = false;
        this.isPlantManager = false;
        this.isprojectManger = false;
        this.isIdmsVisible = false;
        this.displayCDMS = false;
        this.displayCDMSLinks = false;
    }

    async ngOnInit(): Promise<void> {
        this.displayCDMS = environment.environmentName == 'dev' ? true : false;
        this.globalEmittersService.refreshOrgName.subscribe((result) => {
            if (result) {
                this.checkOrganization();
                this.globalEmittersService.refreshOrgName.next(false);
            }
        });
        this.checkOrganization();
        //check for menu visible
        this.isIdmsVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-idms-menu', userActions.View);
        this.isMatrixVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-matrix', userActions.View);
        this.isStandardFlange = await this.user_utility.checkUserPermissionDataAndRoute('standardflange/:isRedirect', userActions.View);
        this.isCustomFlange = await this.user_utility.checkUserPermissionDataAndRoute('customflange/:isRedirect', userActions.View);
        this.isClamp = await this.user_utility.checkUserPermissionDataAndRoute('clamp/:isRedirect', userActions.View);
        this.isEngineeredJointVisible = await this.user_utility.checkUserPermissionDataAndRoute('engineeredjoint/:isRedirect', userActions.View);
        this.isInformateVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-informate', userActions.View);
        this.isMatrixVisible = await this.user_utility.checkUserPermissionDataAndRoute('matrix', userActions.View);
        this.isDashboardVisible = await this.user_utility.checkUserPermissionDataAndRoute('dashboard', userActions.View);
        const userData = this.user_utility.getUserData();
        this.isIceDatabaseVisible =
            (userData?.isSysAdmin && userData?.license.isValid && (userData?.license.instanceTypeIndex == 1 || userData?.license.instanceTypeIndex == 3)) ??
            false;

        // * checking access level
        this.isPlantManager = await this.user_utility.checkUserPermissionDataAndRoute('plantmanager/:isRedirect', userActions.View);
        this.isprojectManger = await this.user_utility.checkUserPermissionDataAndRoute('idms/project-manager', userActions.View);
        this.isReports = await this.user_utility.checkUserPermissionDataAndRoute('reports', userActions.View);

        this.headerContainerCSSClasses = this.layout.getStringCSSClasses('header_container');
        this.headerMenuSelfDisplay = this.layout.getProp('header.menu.self.display');
        this.asideSelfDisplay = this.layout.getProp('aside.self.display');
        this.headerMenuSelfStatic = this.layout.getProp('header.menu.self.static');
        this.headerSelfTheme = this.layout.getProp('header.self.theme') || '';
        this.headerLogo = this.getLogoURL();
        this.headerMenuCSSClasses = this.layout.getStringCSSClasses('header_menu');
        this.headerMenuHTMLAttributes = this.layout.getHTMLAttributes('header_menu');

        this.ulCSSClasses = this.layout.getStringCSSClasses('header_menu_nav');
        this.rootArrowEnabled = this.layout.getProp('header.menu.self.rootArrow');
        this.headerMenuDesktopToggle = this.layout.getProp('header.menu.desktop.toggle');

        //check for license
        this.globalEmittersService.isLicenseValid.subscribe((result) => {
            if (!result) {
                this.disabled = result;
            }
        });

        let selectedInsDetails = JSON.parse(localStorage.getItem('selectedInstanceDetails'));

        if (InstanceTypes.ICE.toLowerCase() === selectedInsDetails?.instanceType?.instanceTypeId || localStorage.getItem('currentInstanceTypeName') == 'ICE') {
            this.isIdmsVisible = false;
        }

        // else {
        //     this.isIdmsVisible = true;
        // }

        // this.globalEmittersService.currentLicenseInstanceTypeIndex.subscribe((result: number) => {
        //     if (result) {
        //         this.isIdmsVisible = LicenceInstanceTypesIndex.ICE !== result;
        //     }
        // });
    }

    checkOrganization() {
        if (localStorage.getItem('selectedOrganizationName') == null || localStorage.getItem('selectedOrganizationName') == undefined) {
            this.displaySelectOrganization = true;
        } else {
            this.displaySelectOrganization = false;
        }
    }

    private getLogoURL(): string {
        let result = 'logo-light.png';

        if (this.headerSelfTheme && this.headerSelfTheme === 'light') {
            result = 'logo-dark.png';
        }

        if (this.headerSelfTheme && this.headerSelfTheme === 'dark') {
            result = 'logo-dark.png';
        }
        return `./assets/media/logos/${result}`;
    }

    @ViewChild('ktHeaderMenu', { static: true }) ktHeaderMenu: ElementRef;
    @HostListener('document:mouseout', ['$event'])
    clickout(event) {
        if (this.eRef.nativeElement.contains(event.target)) {
        } else {
            this.isIdmsShown = false;
            this.isInformateShown = false;
            this.open = false;
        }
    }

    showIdms() {
        document.getElementById('one').style.display = 'grid';
    }

    showInformate() {
        document.getElementById('two').style.display = 'grid';
    }

    notIdms() {
        document.getElementById('one').style.display = 'none';
    }

    notInformate() {
        document.getElementById('two').style.display = 'none';
    }

    showCDMS() {
        this.displayCDMSLinks = true;
        const el = document.getElementById('cdms');
        if (el) {
            this.displayCDMSLinks = true;
            el.style.display = 'grid';
        }
    }

    notCDMS() {
        this.displayCDMSLinks = true;
        const el = document.getElementById('cdms');
        if (el) {
            el.style.display = 'none';
        }
    }

    navigateUrl(url: string) {
        //Case when user selects a calctype and user wants to navigate to particular calculation, need to store the calculation type
        localStorage.setItem('selectedURL', '');
        if (localStorage.getItem('selectedOrganizationName') == null || localStorage.getItem('selectedOrganizationName') == undefined) {
            localStorage.setItem('selectedURL', url);
            this.router.navigate(['/management/organization']);
        } else if (localStorage.getItem('currentInstanceName') == null || localStorage.getItem('currentInstanceName') == undefined) {
            localStorage.setItem('selectedURL', url);
            this.router.navigate(['management/instance'], {
                queryParams: {
                    organizationId: `${localStorage.getItem('selectedOrgId')}`,
                },
            });
        } else {
            switch (url) {
                case 'Standard Flange':
                    this.globalEmittersService.selectedCalcType.next(url.replace(/\s/g, '').toLowerCase());
                    this.router.navigate(['/informate/standardflange/false']);
                    break;
                case 'Custom Flange':
                    this.globalEmittersService.selectedCalcType.next(url.replace(/\s/g, '').toLowerCase());
                    this.router.navigate(['/informate/customflange/false']);
                    break;
                case 'Clamp':
                    this.globalEmittersService.selectedCalcType.next(url.replace(/\s/g, '').toLowerCase());
                    this.router.navigate(['/informate/clamp/false']);
                    break;
                case 'Engineered Joint':
                    this.globalEmittersService.selectedCalcType.next(url.replace(/\s/g, '').toLowerCase());
                    this.router.navigate(['/informate/engineeredjoint/false']);
                    break;
                case 'Matrix':
                    this.router.navigate(['/informate/matrix']);
                    break;
                case 'Plant Manager':
                    this.router.navigate(['/idms/plantmanager']);
                    break;
                case 'Project Manager':
                    this.router.navigate(['/idms/project-manager']);
                    break;
                case 'Reports':
                    this.router.navigate(['/idms/reports']);
                    break;
                case 'Dashboard':
                    this.router.navigate(['/idms/dashboard']);
                    break;
                case 'Ice Database':
                    this.router.navigate(['informate/icedatabase']);

                case 'CDMS_Dashboard':
                    this.router.navigate(['cdms/dashboard']);
                    break;
                case 'CDMS_TrainingUnits':
                    this.router.navigate(['cdms/trainingunits']);
                    break;
                case 'CDMS_Personnel':
                    this.router.navigate(['cdms/personnel']);
                    break;
                case 'CDMS_Reports':
                    this.router.navigate(['cdms/reports']);
                    break;
                default:
            }
        }
    }

    barcodePopUp() {
        let dialogRef = this.modalService.open(ScanBarcodeComponent, {
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            size: 'md',
            keyboard: false,
        });
    }
}
